/**
 * Flyouts Vue composable
 * ------------------------------------------------------------------------------
 * Handle menus and other global flyouts.
 */

import { reactive, ref, watch } from 'vue'

const flyouts = reactive({
  menu: false,
  minicart: false,
  search: false
})

const scrollLock = {
  menu: true,
  minicart: false,
  search: false
}

export function useFlyouts () {
  const scrollPosition = ref(0)

  function toggleFlyout (item) {
    for (const flyout in flyouts) {
      flyouts[flyout] = flyout === item
        ? !flyouts[flyout]
        : false
    }
  }

  watch(flyouts, (item) => {
    if (!scrollLock[item]) return

    if (Object.values(item).find(item => item === true)) {
      scrollPosition.value = window.pageYOffset

      document.body.classList.add('no-scroll')
      document.body.style.top = `-${scrollPosition.value}px`
    } else {
      document.body.classList.remove('no-scroll')

      document.body.style.removeProperty('top')
      window.scrollTo(0, scrollPosition.value)
    }
  })

  return {
    flyouts,
    toggleFlyout
  }
}
